import { Injectable } from '@angular/core';
import { ReplaySubject, PartialObserver, Observable, Subject, BehaviorSubject } from 'rxjs';
import { IAccountType } from '../constants/account-types';
import { AuthService } from './auth.service';

const NET_STABILITY_INTERVAL = 5*1000;
const NET_STABILITY_STEPS = Math.floor(20 / 5);

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService {

  private loginReq:BehaviorSubject<boolean> = new BehaviorSubject(false);
  private devNetFail:BehaviorSubject<boolean> = new BehaviorSubject(false);
  private apiNetFail:BehaviorSubject<boolean> = new BehaviorSubject(false);
  private supportReq:BehaviorSubject<boolean> = new BehaviorSubject(false);
  private confirmationReq:BehaviorSubject<{caption: string, confirm:()=>any}> = new BehaviorSubject(null);
  
  private isActivated:boolean;
  private isAuthenticated:boolean;
  private isReauthCompleted:boolean;
  private isDevNetOnline:boolean;
  private isDevNetOnlinePersistent:boolean; // needs to be persistently bad for NET_STABILITY_STEPS before this is activated
  
  private isValidAccountType:boolean;
  private isMonitoringDevNet:boolean
  private currentAccountType:IAccountType;
  private devNetDiscrepCounter = 0;

  constructor(
    private auth: AuthService,

  ) { 
    this.loginReq.next(false);
    this.apiNetFail.next(false);
    this.updateOnlineStatus(); // devNetFail can be checked right away
    
    setInterval(this.monitorDevNet, NET_STABILITY_INTERVAL)
    this.auth.registerNoApiNetSub(this.apiNetFail);
    window.addEventListener('online',  this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
    this.auth.user().subscribe(this.updateUserInfo);
    this.auth.getReauthCompletedSub().subscribe(this.updateReauthCompleted)
  }

  private updateOnlineStatus = (e?:any) => {
    this.isDevNetOnline = navigator.onLine;
    if (this.isMonitoringDevNet){
      this.devNetDiscrepCounter = 0;
    }
    else {
      if (this.isDevNetOnline !== this.isDevNetOnlinePersistent){
        this.devNetDiscrepCounter = 0;
        this.isMonitoringDevNet = true;
      }
    }
  }
  
  private monitorDevNet = () => {
    if (this.isMonitoringDevNet){
      this.devNetDiscrepCounter ++;
      // console.log('this.devNetDiscrepCounter', this.devNetDiscrepCounter)
      if (this.devNetDiscrepCounter >= NET_STABILITY_STEPS){
        this.concludeDevNet();
      }
    }
  }
  private concludeDevNet(){
    this.isMonitoringDevNet = false;
    const v = this.isDevNetOnline;
    if (this.isDevNetOnlinePersistent !== v){ // this check should not be required, but just making sure so that we have the right rate limiting on the BSubject
      this.isDevNetOnlinePersistent = v;
      this.devNetFail.next(!v);
    }
    
  }

  private updateReauthCompleted = (v:boolean) => {
    this.isReauthCompleted = v;
    this.updateLoginReqState();
  }

  private updateUserInfo = (userInfo) => {
    if (userInfo){
      this.isAuthenticated = true;
      this.currentAccountType = userInfo.accountType
    }
    else{
      this.isAuthenticated = false;
      this.currentAccountType = null;
    }
    this.updateLoginReqState();
  }

  isAuthActive(){
    return this.isAuthenticated;
  }
  
  getLoginReq(){  return this.loginReq; }
  getDevNetFail(){return this.devNetFail; }
  getApiNetFail(){return this.apiNetFail; }
  getSupportReq(){return this.supportReq; }
  getConfirmationReq(){return this.confirmationReq; }
  
  updateLoginReqState(){
    const isLoginReq = this.isReauthCompleted && this.isActivated && !this.isAuthenticated;
    // console.log('updateLoginReqState', isLoginReq, this.isReauthCompleted, this.isActivated, this.isAuthenticated)
    if (this.loginReq.getValue() !== isLoginReq){
      this.loginReq.next(isLoginReq);
    }
  }
  
  activate(accountTypes?:IAccountType[]){
    this.isActivated = true;
    if (accountTypes){
      if (accountTypes.indexOf(this.currentAccountType) === -1){
        this.isValidAccountType = false;
      }
      else{
        this.isValidAccountType = true;  
      }
    }
    else{
      this.isValidAccountType = true;
    }
    this.updateLoginReqState();
  }

  deactivate(){
    this.isActivated = false;
    this.updateLoginReqState();
  }
  supportReqActivate(){
    this.supportReq.next(true);
  }
  supportReqDeactivate(){
    this.supportReq.next(false);
  }
  confirmationReqActivate(caption: string, confirm:()=>any){
    this.confirmationReq.next({caption, confirm});
  }
  confirmationReqDeactivate(){
    this.confirmationReq.next(null);
  }
  
  

}
